import classNames from 'classnames';
import { Fragment } from 'react';

import ErrorBoundary from '../components/ErrorBoundary';
import { InnerContentScrollbars } from '../components/layout/InnerContentScrollbars';
import {
  HorizontalTrackTypes,
  Scrollbars,
} from '../components/layout/Scrollbars';
import AccountTopBar from '../widgets/AccountTopBar';
import LoggedFooter from '../widgets/LoggedFooter';
import MainMenuHeader from '../widgets/MainMenuHeader';

export default function BaseLoggedPage({
  id,
  className,
  children,
  wrapInScrollbar,
}) {
  const Wrapper = wrapInScrollbar ? InnerContentScrollbars : Fragment;
  return (
    <Scrollbars
      id={id}
      className={classNames('BaseLoggedPage', className)}
      horizontal={HorizontalTrackTypes.BOTTOM}
      spaceOutside
    >
      <div className="BaseLoggedPage-Content">
        <AccountTopBar />
        <MainMenuHeader />
        <div className="BaseLoggedPage-InnerContent">
          <Wrapper>
            <ErrorBoundary messageId="error.render.page">
              {children}
            </ErrorBoundary>
          </Wrapper>
        </div>
        <LoggedFooter />
      </div>
    </Scrollbars>
  );
}
